import { useState } from "react";

export default function InlineHintsDemo() {
  const [selectedCat, setSelectedCat] = useState("cabling");
  const [selectedLevel, setSelectedLevel] = useState(null);

  const categories = [
    { id: "cabling", title: "Câblage", subtitle: "Branchements des serveurs" },
    { id: "terminal", title: "Terminal", subtitle: "Ordre des formes" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div>
        <div style={{ fontSize: 9, letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(100,116,139,.7)", fontFamily: "ui-monospace,monospace", marginBottom: 7 }}>Choisir une énigme</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
          {categories.map(cat => (
            <button key={cat.id} type="button" onClick={() => setSelectedCat(cat.id)}
              style={{
                textAlign: "left", padding: "9px 11px", borderRadius: 8, cursor: "pointer",
                border: selectedCat === cat.id ? "1px solid rgba(99,102,241,.45)" : "1px solid rgba(255,255,255,.07)",
                background: selectedCat === cat.id ? "rgba(99,102,241,.15)" : "rgba(255,255,255,.03)",
                transition: "all .15s",
              }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: selectedCat === cat.id ? "rgba(165,180,252,.95)" : "rgba(226,232,240,.8)", fontFamily: "ui-sans-serif,system-ui" }}>{cat.title}</div>
              <div style={{ fontSize: 10, color: "rgba(100,116,139,.7)", fontFamily: "ui-sans-serif,system-ui", marginTop: 2 }}>{cat.subtitle}</div>
            </button>
          ))}
        </div>
      </div>

      <div>
        <div style={{ fontSize: 9, letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(100,116,139,.7)", fontFamily: "ui-monospace,monospace", marginBottom: 7 }}>Niveau d'indice</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {[
            { id: "l1", label: "Niveau 1", color: "rgba(99,102,241,.9)" },
            { id: "l2", label: "Niveau 2", color: "rgba(99,102,241,.9)" },
            { id: "l3", label: "Niveau 3", color: "rgba(99,102,241,.9)" },
            { id: "answer", label: "Réponse", color: "rgba(245,158,11,.9)" },
          ].map(lvl => (
            <button key={lvl.id} type="button" onClick={() => setSelectedLevel(lvl.id)}
              style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "6px 12px", borderRadius: 20, cursor: "pointer",
                border: selectedLevel === lvl.id ? `1px solid ${lvl.color}` : "1px solid rgba(255,255,255,.08)",
                background: selectedLevel === lvl.id ? lvl.color.replace(".9)", ".15)") : "rgba(255,255,255,.03)",
                color: selectedLevel === lvl.id ? "rgba(226,232,240,.95)" : "rgba(148,163,184,.65)",
                fontSize: 11, fontWeight: 700, fontFamily: "ui-monospace,monospace",
                transition: "all .15s",
              }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: selectedLevel === lvl.id ? lvl.color : "rgba(255,255,255,.15)", boxShadow: selectedLevel === lvl.id ? `0 0 8px ${lvl.color}` : "none", flexShrink: 0 }} />
              {lvl.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: "10px 12px", borderRadius: 8, background: "rgba(255,255,255,.025)", border: "1px solid rgba(255,255,255,.07)", minHeight: 48 }}>
        <div style={{ fontSize: 11, color: selectedLevel ? "rgba(226,232,240,.85)" : "rgba(100,116,139,.55)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
          {selectedLevel
            ? `Contenu de l'indice ${selectedLevel === "answer" ? "Réponse" : "Niveau " + selectedLevel.replace("l", "")} pour "${categories.find(c => c.id === selectedCat)?.title}"…`
            : "Sélectionnez un niveau pour afficher un indice."}
        </div>
      </div>
    </div>
  );
}